import React, { memo } from 'react'
import PropTypes from 'prop-types'
import dynamic from 'next/dynamic'

const DocumentsSection = memo(({ theme, sectionId }) => {
  const DocumentsLayout = dynamic(() => import(/* webpackChunkName: 'DocumentsSectionLayout' */ `../../../../../containers/home-page/views/sections/documents/layouts/${theme.layout}`))

  return (
    <DocumentsLayout sectionId={sectionId} />
  )
}, (prevProps, nextProps) => {
  return (prevProps.theme && prevProps.theme.layout) === (nextProps.theme && nextProps.theme.layout)
})

DocumentsSection.propTypes = {
  theme: PropTypes.object,
  sectionId: PropTypes.number
}

export default DocumentsSection
